import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7d43d394"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "van-doc-card"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Please fill in the UPI Ref No you got after the transfer, So that we can confirm the order", -1));

const _hoisted_5 = {
  class: "utr"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "reference"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "reference"
}, "UPI Ref No or UTR or Transaction ID")], -1));

const _hoisted_7 = /*#__PURE__*/_createTextVNode("Complete Payment");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");

  const _component_van_popover = _resolveComponent("van-popover");

  const _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_popover, {
    show: $data.showPopover,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.showPopover = $event),
    theme: "dark",
    "close-on-click-outside": false,
    "close-on-click-action": false,
    placement: "top",
    onClosed: $options.closed
  }, {
    reference: _withCtx(() => [_createVNode(_component_van_field, {
      type: "number",
      maxlength: "12",
      modelValue: $data.utrvalue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.utrvalue = $event),
      label: "UPI-Ref-No",
      placeholder: "UPI Ref No or UTR or Transaction ID"
    }, null, 8, ["modelValue"])]),
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["show", "onClosed"])])])]), _createVNode(_component_van_button, {
    type: "success",
    class: "cofbutton",
    onClick: $options.submitutr,
    disabled: $data.disabled
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }, 8, ["onClick", "disabled"])]);
}